// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1XMzU","bigColWidth":"Table_bigColWidth__32xPQ","biggerColWidth":"Table_biggerColWidth__3Bj8V","row":"Table_row__3zhlF","col":"Table_col__XxxEs"};